import { FC } from "react";
import { getDataAutomationGroup, getDataLinkAttributes } from "@/helpers";
import { ArrowLeftCircleFilled, ArrowLeftCircleLine } from "@/icons";

interface ArrowProps {
  dlt?: string;
  dld?: string;
  disabled: boolean;
  clickHandler: VoidFunction;
}
interface TabsPagerProps {
  title?: string;
  previousArrow: ArrowProps;
  nextArrow: ArrowProps;
}

export const VerticalTabPager: FC<TabsPagerProps> = ({
  title,
  previousArrow,
  nextArrow,
}) => {
  return (
    <div
      className="flex w-fit flex-row items-center gap-3 self-end"
      {...getDataAutomationGroup("pagination")}
    >
      <span className="font-red-hat-display text-body-s text-body-secondary">
        {title}
      </span>
      <button
        disabled={previousArrow.disabled}
        {...getDataLinkAttributes({
          dlt: previousArrow.dlt,
          dld: previousArrow.dld,
        })}
        onClick={previousArrow.clickHandler}
        data-automation-id="up-arrow"
        aria-label={`${title ? title : "Pager"} Up`}
        className="group-hover:group-enabled:text-link-hover group-active:group-enabled:text-arrow-active group-disabled:text-arrow-disabled text-link group focus-visible:outline-swdc-blue-400 outline outline-transparent focus-visible:rounded-full disabled:cursor-not-allowed"
      >
        <ArrowLeftCircleFilled
          width={32}
          height={32}
          fill="currentColor"
          className="rotate-90 group-hover:hidden group-active:hidden group-disabled:hidden"
        />
        <ArrowLeftCircleLine
          width={32}
          height={32}
          fill="currentColor"
          className="hidden rotate-90 group-hover:group-enabled:block group-active:group-enabled:block group-disabled:block"
        />
      </button>
      <button
        disabled={nextArrow.disabled}
        {...getDataLinkAttributes({
          dlt: nextArrow.dlt,
          dld: nextArrow.dld,
        })}
        onClick={nextArrow.clickHandler}
        aria-label={`${title ? title : "Pager"} Down`}
        data-automation-id="down-arrow"
        className="group-hover:group-enabled:text-link-hover group-active:group-enabled:text-arrow-active group-disabled:text-arrow-disabled text-link group focus-visible:outline-swdc-blue-400 outline outline-transparent focus-visible:rounded-full disabled:cursor-not-allowed"
      >
        <ArrowLeftCircleFilled
          width={32}
          height={32}
          fill="currentColor"
          className="-rotate-90 group-hover:hidden group-active:hidden group-disabled:hidden"
        />
        <ArrowLeftCircleLine
          width={32}
          height={32}
          fill="currentColor"
          className="hidden -rotate-90 group-hover:group-enabled:block group-active:group-enabled:block group-disabled:block"
        />
      </button>
    </div>
  );
};
